import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/home/Home.vue'
import OnlineInvoicing from '../view/home/OnlineInvoicing.vue'
import CompanyStrength from '../view/home/CompanyStrength'
import companyShows from '../view/home/companyShows'
import AboutUs from '../view/home/AboutUs'
import contact from '../view/home/contact'
import mall from '../view/mall/index'
import details from '../view/mall/details'
import product from '../view/home/product'
import my from '../view/home/my'
import mian from '../view/home/main'
import password from '../view/ChildComponents/password'
import login from '../view/ChildComponents/login'
import registered from '../view/ChildComponents/registered'
import ForgotPassword from '../view/ChildComponents/ForgotPassword'
import MyProfile from '../view/my/MyProfile'
import print from '../view/home/print'
import members from '../view/home/members'
import single from '../view/home/single'
import pay from '../view/my/pay'
import orderImmediately from '../view/my/orderImmediately'
import memberCenter from '../view/my/memberCenter'
import myOrder from '../view/my/myOrder'
import coupons from '../view/my/coupons'
import Invoice from '../view/my/Invoice'
import address from '../view/my/address'
import PointsFor from '../view/my/PointsFor'
import myLower from '../view/my/myLower'
import alipay from "../view/pay/index.vue"
import VueRouter from 'vue-router'

Vue.use(Router)


const routes = [
    {
        path: "/alipay",
        component: alipay
    },
    {
        path: "/members",
        component: members,
        redirect: '/my',
        children: [
            {
                path: '/my',
                component: my,
                redirect: '/memberCenter',
                children: [
                    {
                        path: '/memberCenter',
                        component: memberCenter
                    },
                    {
                        path: '/myOrder',
                        component: myOrder
                    },
                    {
                        path: '/coupons',
                        component: coupons
                    },
                    {
                        path: '/MyProfile',
                        component: MyProfile
                    },
                    {
                        path: '/Invoice',
                        component: Invoice
                    }, {
                        path: "/address",
                        component: address
                    },
                    {
                        path: "/PointsFor",
                        component: PointsFor
                    },
                    {
                        path: "/myLower",
                        component: myLower
                    },
                ]
            },
            {
                path: '/single',
                name: 'single',
                component: single
            },
            {
                path: '/pay',
                name: 'pay',
                component: pay
            },
            {
                path: '/orderImmediately',
                name: 'orderImmediately',
                component: orderImmediately
            }
        ]
    },
    {
        path: '/print',
        name: 'print',
        component: print
    },
    {
        path: '/ForgotPassword',
        component: ForgotPassword
    },
    {
        path: '/registered',
        component: registered
    },
    {
        path: '/password',
        component: password
    },
    {
        path: '/login',
        component: login
    },
    {
        path: '/',
        component: mian,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'home',
                component: Home
            },
            {
                path: "/product",
                component: product
            },
            {
                path: '/contact',
                component: contact
            },
            {
                path: '/AboutUs',
                component: AboutUs
            },
            {
                path: '/companyShows',
                path: '/companyShows',
                component: companyShows
            },
            {
                path: '/CompanyStrength',
                component: CompanyStrength
            },
            {
                path: '/OnlineInvoicing',
                component: OnlineInvoicing
            },
            {
                path: '/mall',
                component: mall
            },
            {
                path: '/details',
                name: details,
                component: details
            },
        ]

    },
]
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    if (to.path === '/') return next()
    if (to.path === '/home') return next()
    if (to.path === '/OnlineInvoicing') return next()
    if (to.path === '/CompanyStrength') return next()
    if (to.path === '/companyShows') return next()
    if (to.path === '/product') return next()
    if (to.path === '/mall') return next()
    if (to.path === '/AboutUs') return next()
    if (to.path === '/contact') return next()
    if (to.path === '/login') return next()
    if (to.path === '/registered') return next()
    let str = window.sessionStorage.getItem('token')
    console.log(str)
    if (!str) next('/login')
    next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js